import api from "@/api/axios/axios.js";

// Base del recurso de Unidades de Negocio.
// El GET ya lo usa NuevoProyecto (getUnitBussines). Aqui se agrega el CRUD.
const BASE = "/login/unit-bussines/";
const BASE2 = "/login/usuarios-por-unidad/";

export async function getUnidades() {
  const resp = await api.get(BASE);
  return resp.data;
}

export async function createUnidad(payload) {
  const resp = await api.post(BASE, payload);
  return resp.data;
}

export async function updateUnidad(id, payload) {
  const resp = await api.patch(`${BASE}${id}/`, payload);
  return resp.data;
}

export async function deleteUnidad(id) {
  const resp = await api.delete(`${BASE}${id}/`);
  return resp;
}


export async function getUserForUnit() {
  const resp = await api.get(BASE2);
  return resp.data;
}

export async function saveUnitForUser(user){
  const resp= await api.patch(BASE2,{
    usuario:user
  })
  console.log(resp)
}


